<ng-template #details>
  <div class="popover-details">
    <div class="property">
      <label>{{ 'orgUserGroup.name' | cxTranslate }}</label>
      <a
        class="value"
        [routerLink]="
          {
            cxRoute: 'orgUserGroupDetails',
            params: model
          } | cxUrl
        "
        >{{ model.name }}</a
        >
      </div>

      <div class="property">
        <label>{{ 'orgUserGroup.roles' | cxTranslate }}</label>
        @for (role of model.roles; track role) {
          <span class="value">
            {{role}}
          </span><br>
        }
      </div>
    </div>
  </ng-template>

  <button
    class="button text"
    >
    {{ model?.name }}
  </button>
  <button
    class="info-btn"
    [cxPopover]="details"
      [cxPopoverOptions]="{
        placement: 'top',
        class: 'my-company-popover',
        displayCloseButton: true
      }"
    >
  </button>

